import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

import React from 'react'

import { Slice } from 'gatsby'

import NewsletterPopup from '@components/Content/NewsletterPopup/NewsletterPopup'

import { CustomizableComponent } from '@contracts/components/customizableComponent'
import { WoocommerceAuth } from '@contracts/context/woocommerceAuth'

import { refreshToken } from '@localApollo/mutations/refreshToken'

import FullPageSpinner from './FullPageSpinner'
import * as styles from './Layout.module.scss'

import 'normalize.css'

import '@styles/global.scss'

interface Props extends CustomizableComponent {
	children: React.ReactNode
	template?: string
	background: 'light' | 'dark'
	spinner?: boolean
}

const Layout: React.FunctionComponent<Props> = (props) => {
	const emptyRef = React.useRef<null | NodeJS.Timer>(null)
	const [showNewsletterPopup, setShowNewsletterPopup] = React.useState(false)

	const mainClasses = [styles.main]

	if (props.className) {
		mainClasses.push(props.className)
	}

	if (props.spinner === true) {
		mainClasses.push(styles.spinner)
	}

	mainClasses.push(styles[props.background])

	const handleTokenRefresh = async () => {
		const auth = JSON.parse(localStorage.getItem('auth') as string) as WoocommerceAuth

		if (auth && auth.authToken) {
			// If we have a token, decode it
			const decoded = jwtDecode<any>(auth.authToken)

			const expireTime = new Date(decoded.exp * 1000).getTime()
			const now = Date.now()

			// If the token isn't expired, skip
			if (now < expireTime) return

			refreshToken(auth.refreshToken).then((res) => {
				if (res.data) {
					const newJWT = res.data.refreshJwtAuthToken

					// Update the token in local storage and state
					const oldAuth = JSON.parse(localStorage.getItem('auth') as string)
					const newAuth = JSON.stringify({
						...oldAuth,
						authToken: newJWT.authToken,
					})

					localStorage.setItem('auth', newAuth)
				}
			})
		}
	}

	React.useEffect(() => {
		handleTokenRefresh()

		emptyRef.current = setInterval(() => {
			handleTokenRefresh()
		}, 60 * 1000)

		const handleMouseLeave = (event: MouseEvent) => {
			if (event.clientY <= 0 && !Cookies.get('newsletterPopupShown')) {
				setShowNewsletterPopup(true)

				Cookies.set('newsletterPopupShown', 'true', { expires: 7 })
			}
		}

		document.addEventListener('mouseout', handleMouseLeave)
		window.addEventListener('mouseleave', handleMouseLeave)

		return () => {
			window.removeEventListener('mouseleave', handleMouseLeave)
			document.removeEventListener('mouseout', handleMouseLeave)

			if (emptyRef.current) {
				clearInterval(emptyRef.current)
			}
		}
	}, [])

	return (
		<>
			<Slice alias="header" template={props.template || ''} />

			<main className={mainClasses.join(' ')}>{props.children}</main>

			<Slice alias="footer" template={props.template || ''} />

			<div id="newsletter-popup"></div>

			{showNewsletterPopup && <NewsletterPopup />}

			{props.spinner === true && <FullPageSpinner />}
		</>
	)
}

export default Layout
